import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Redux/Store/index";
import { NotificationContainer } from "react-notifications";
import { LoadingAlert } from "./Common";
import "react-notifications/lib/notifications.css";
import { Routers } from "./Router/Routers";
import "./index.css";

// ✅ SETUP GLOBAL ERROR HANDLER - Catch tất cả unhandled promise rejection
import { setupGlobalErrorHandler } from './Redux/Actions/GlobalSafeWrapper';
import { startVersionCheck } from "./Utils";
setupGlobalErrorHandler();

// ✅ START VERSION CHECK - Tự động kiểm tra version mới và reload
startVersionCheck();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<BrowserRouter>
  <Provider store={store}>
    <Routers />
    <NotificationContainer />
    <LoadingAlert />
  </Provider>
</BrowserRouter>);
